import { showToast } from '../../application/utils/toast.util';
import {clientAccount} from '../../core/stores';
import {MUTATION_SIGN_IN} from '../../core/graphql/types';

export function MutationSignIn(authForm, setSubmitting): Promise {
  return new Promise((resolve,reject) => {
    const {email, password} = authForm;
    setSubmitting(true);
    if(!email || !password){
      showToast({html: 'Para entrar, você precisa preencher todos os campos', displayLength: 5000})
      reject(false);
      setSubmitting(false);
      return;
    }
    if(email && !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email))){
      showToast({html: 'Para entrar, você precisa preencher um email válido', displayLength: 5000})
      reject(false);
      setSubmitting(false);
      return;
    }
    if(password && password.length < 8){
      showToast({html: 'Para entrar, sua senha precisa ter no mínimo 8 caracteres', displayLength: 5000})
      reject(false);
      setSubmitting(false);
      return;
    }

    clientAccount.mutate({
      mutation: MUTATION_SIGN_IN,
      variables: authForm,
    })
    .then(response => {
      const {data} = response;
      const {login} = data || {};
      showToast({html: 'Login realizado com sucesso!'});
      setSubmitting(false);
      resolve({status: 'success', user: login})
    })
    .catch( err => {
      console.log('ERROR ==> ', err)
      setSubmitting(false);
      const errorMessage = err.graphQLErrors.map((error) => error.message).join(',');
      showToast({ html: 'Houve um erro na sua solicitação.' })
      showToast({ html: errorMessage })
      reject({status: 'error', message: errorMessage})
    });
  });
}